import React from 'react';
import './Button.sass';
import cx from 'classnames';
import Loader from "../loader/Loader";

export default function Button({component = 'button', big, medium, small, extraSmall, filled, full, more, wide, iconed, sign, clip, mod, loading, disabled, children, onClick, ...rest}) {
  const Component = component;

  return (
    <Component
      className={cx({
        btn: true,
        'btn--big': big,
        'btn--medium': medium,
        'btn--small': small,
        'btn--extraSmall': extraSmall,
        'btn--filled': filled,
        'btn--full': full,
        'btn--more': more,
        'btn--wide': wide,
        'btn--iconed': iconed,
        'btn--sign': sign,
        'btn--clip': clip,
        'btn--disabled': disabled,
        [`btn--${mod}`]: !!mod,
      })}
      disabled={disabled}
      onClick={onClick}
      {...rest}
    >
      {loading ? (
        <span className="btn__loader">
          <Loader button alt={disabled || filled} />
        </span>
      ) : (
        children
      )}
    </Component>
  );
}



// WEBPACK FOOTER //
// ./components/button/Button.js